import React from 'react';
import GeneralLoadingPage from 'js/Pages/GeneralLoadingPage.js';
import PageCouldNotBeLoaded from 'js/Pages/PageCouldNotBeLoaded.js';


export default class LazyPageLoader {
    constructor( pageModuleLoaderPromise ,  location , onUpdate  , startupData ,appReducer ){
        this.appReducer = appReducer;
        this.pageModuleLoaderPromise = pageModuleLoaderPromise;
        this.location = location;
        this.onUpdate = onUpdate;
        this.pageLoaderModule = null;
        this.startupData = startupData;
        this.triggerUpdateAlert = this.triggerUpdateAlert.bind(this);
        this.isFullyLoaded = this.isFullyLoaded.bind(this);
        this.canBeShown = this.canBeShown.bind(this);
        this.canHandleRequest = this.canHandleRequest.bind(this);
        this.handleRequest = this.handleRequest.bind(this);
        this.getRenderComponent = this.getRenderComponent.bind(this);
        this.loadPageLoader = this.loadPageLoader.bind(this);
        this.errorLoading = false;
        this.loadPageLoader();
    }

    canHandleRequest(location){
        if( !this.pageLoaderModule?.canHandleRequest ){
            return false;
        }
        return this.pageLoaderModule.canHandleRequest(location);
    }

    handleRequest(location){
        if( !this.pageLoaderModule?.handleRequest ){
            return false;
        }

        this.pageLoaderModule.handleRequest(location);
    }


    triggerUpdateAlert(){
        if( this.onUpdate ){
            this.onUpdate();
        }
    }

    loadPageLoader() {
        this.pageModuleLoaderPromise().then((module) => {
            this.pageLoaderModule = new module.default( this.location , this.triggerUpdateAlert , this.startupData , this.appReducer ) ;
            this.errorLoading = false;
            this.triggerUpdateAlert();
        }).catch(( error) => {
          this.errorLoading = true;
            this.triggerUpdateAlert();
          setTimeout( ()=> {   this.loadPageLoader(); } , 3000);
        });
    }

    isFullyLoaded(){
      if( this.errorLoading){
        return true;
      }

        if( !this.pageLoaderModule ){
            return false;
        }
        return  this.pageLoaderModule.isFullyLoaded();
    }
    canBeShown(){
      if( this.errorLoading){
        return true;
      }
        if( !this.pageLoaderModule ){
            return false;
        }
        return this.pageLoaderModule.canBeShown();;
    }
    getRenderComponent(){

      if( this.errorLoading){
        return <PageCouldNotBeLoaded />;
      }

        if( !this.pageLoaderModule){
            return <GeneralLoadingPage />;
        }

        return this.pageLoaderModule.getRenderComponent();
    }
}
